import React from "react";
import Button from "../../shared/button/Button";
import InnerHtml from "../../shared/innerHtml/InnerHtml";
import { cmsLink } from "../../../utils/link.utils";

const Intro = ({ intl, closePopupAndSave, deviceType }) => {
  const cookieUrl = cmsLink(intl.formatMessage({ id: "CookiePage.url" }));
  const buttonText = intl.formatMessage({ id: "CookieMessage.link" });

  const handleAcceptClick = () => {
    closePopupAndSave();
  };

  return (
    <>
      <p>{intl.formatMessage({ id: "CookieMessage.intro.body" })}</p>
      <ul>
        <li>{intl.formatMessage({ id: "CookieMessage.intro.list.1" })}</li>
        <li>{intl.formatMessage({ id: "CookieMessage.intro.list.2" })}</li>
        <li>{intl.formatMessage({ id: "CookieMessage.intro.list.3" })}</li>
      </ul>
      {deviceType.isSmall ? (
        <>
          <div className="cookie-message__footer cookie-message__footer--no-border">
            <Button
              appearance="primary"
              onClick={handleAcceptClick}
              text={buttonText}
            />
          </div>

          <InnerHtml
            html={intl.formatMessage(
              { id: "CookieMessage.intro.extra" },
              { legalLink: cookieUrl }
            )}
          />
        </>
      ) : (
        <>
          <InnerHtml
            html={intl.formatMessage(
              { id: "CookieMessage.intro.extra" },
              { legalLink: cookieUrl }
            )}
          />

          <div className="cookie-message__footer cookie-message__footer--no-border">
            <Button
              appearance="primary"
              onClick={handleAcceptClick}
              text={buttonText}
            />
          </div>
        </>
      )}
    </>
  );
};

export default Intro;
